import { cn } from '@/lib/utils'

import { VideoBadge } from './VideoBadge'

interface ProductImageProps {
  name: string
  url: string
  imageUrl?: string
  hoverImageUrl?: string | null
  imageLoading?: 'lazy' | 'eager'
  hasVideo?: boolean
}

const PLACEHOLDER_IMAGE = '/media/catalog/product/placeholder/default/placeholder.jpg'

const WRAPPER_CLASSES = 'relative w-full min-h-[280px] h-[320px] xl:h-[380px] max-h-[400px] flex justify-center items-center overflow-hidden focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-button-color'

const IMAGE_CLASSES = 'w-full h-full object-contain object-center min-h-[250px] max-h-[380px] min-w-[150px] max-w-full text-sm transition-opacity duration-300 ease-in-out'

const HOVER_IMAGE_CLASSES = 'absolute inset-0 w-full h-full object-contain object-center min-h-[280px] max-h-[400px] opacity-0 group-hover:opacity-100 group-hover:scale-105 transition-all duration-300 ease-in-out'

export function ProductImage({
  name,
  url,
  imageUrl,
  hoverImageUrl,
  imageLoading = 'lazy',
  hasVideo,
}: ProductImageProps) {
  const displayImage = imageUrl || PLACEHOLDER_IMAGE

  return (
    <a
      href={url}
      aria-label={name}
      className={WRAPPER_CLASSES}
    >
      <img
        src={displayImage}
        alt={name}
        width={400}
        height={400}
        loading={imageLoading}
        className={cn(
          IMAGE_CLASSES,
          hoverImageUrl && 'group-hover:opacity-0'
        )}
      />
      {hoverImageUrl && (
        <img
          src={hoverImageUrl}
          alt={`${name} - alternate view`}
          width={400}
          height={400}
          loading="lazy"
          className={HOVER_IMAGE_CLASSES}
        />
      )}
      <VideoBadge hasVideo={hasVideo} />
    </a>
  )
}
